import React, {useMemo} from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {Button, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'

const StyledContainer = styled.div`
  ${({theme}) => ({backgroundColor: theme.white_3})}
  min-height: ${convertUnit(64)};
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 0 ${convertUnit(20)};
`
const StyledButton = styled(Button)`
  width: fill-available;
  margin: ${convertUnit(20)} 0;
`

export interface GiftShopMessageRoomInputDisabledProps {
  type: 'banned' | 'system' | 'blocked'
  onClickButton?(): void
}

export default function GiftShopMessageRoomInputDisabled({
  type = 'system',
  onClickButton,
}: GiftShopMessageRoomInputDisabledProps) {
  const {translate} = useTranslation()
  const renderContent = useMemo(() => {
    switch (type) {
      case 'banned':
        return (
          <>
            <Paragraph fontWeight="medium" fontSize="m" color="gray_3">
              {translate('messages:bannedTitle')}
            </Paragraph>
            <Paragraph color="gray_3">
              {translate('messages:bannedDesc')}
            </Paragraph>
          </>
        )
      case 'blocked':
        return (
          <>
            <Paragraph fontWeight="medium" fontSize="m" color="gray_3">
              {translate('messages:blockedTitle')}
            </Paragraph>
            <Paragraph color="gray_3">
              {translate('messages:bannedDesc')}
            </Paragraph>
            <StyledButton
              label={translate('giftShop:unblock')}
              onClick={onClickButton}
            />
          </>
        )
      default:
        return (
          <Paragraph fontSize="m" color="gray_3">
            {translate('messages:system_input')}
          </Paragraph>
        )
    }
  }, [onClickButton, translate, type])

  return <StyledContainer>{renderContent}</StyledContainer>
}
